// External modules
import acHTTPClient from 'services/ACHTTPClient';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';
import { onAuthError } from '../auth';

// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;

const getItemsError = error => {
  return {
    type: constants.GET_ITEMS_ERROR,
    error,
  };
};

const getItemsByProviderIdError = error => {
  return {
    type: constants.GET_ITEMS_BY_PROVIDER_ID_ERROR,
    error,
  };
};

const getItemsByProviderIdSuccess = items => {
  return {
    type: constants.GET_ITEMS_BY_PROVIDER_ID_SUCCESS,
    items: items,
  };
};

const getItemsSuccess = items => {
  return {
    type: constants.GET_ITEMS_SUCCESS,
    items: items,
  };
};

const getNotActiveItemsSuccess = items => {
  return {
    type: constants.GET_NOT_ACTIVE_ITEMS_SUCCESS,
    items: items
  }
}

const getItemByIdError = error => {
  return {
    type: constants.GET_ITEM_BY_ID_ERROR,
    error,
  };
};

const getItemByIdSuccess = items => {
  return {
    type: constants.GET_ITEM_BY_ID_SUCCESS,
    items: items,
  };
};

const getItemsByProviderId = (providerId, isNotInactive) => {
  let apiURL = `${experienceAPIURL}/providers/${providerId}/items`;
  if (isNotInactive) {
    apiURL += '?isNotInactive=true';
  }
  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getItemsByProviderIdError(response.statusText));
        }
        dispatch(getItemsByProviderIdSuccess(response.data));
      })
      .catch(error => {
        dispatch(getItemsByProviderIdError(error));
      });
  };
};

const getItems = (isNotActive) => {
  let apiURL = `${experienceAPIURL}/items`;
  if(isNotActive) {
    apiURL += '?isNotActive=true'
  }
  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getItemsError(response.statusText));
        }
        if(!isNotActive) {
          dispatch(getItemsSuccess(response.data));
        }
        if(isNotActive) {
          dispatch(getNotActiveItemsSuccess(response.data))
        }
      })
      .catch(error => {
        dispatch(getItemsError(error));
      });
  };
};

const getItemById = id => {
  let apiURL = `${experienceAPIURL}/items/${id}`;
  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getItemByIdError(response.statusText));
        }
        dispatch(getItemByIdSuccess(response.data));
      })
      .catch(error => {
        dispatch(getItemByIdError(error));
      });
  };
};

const postItemError = error => {
  return {
    type: constants.POST_ITEM_ERROR,
    error,
  };
};

const postItemSuccess = newId => {
  return {
    type: constants.POST_ITEM_SUCCESS,
    newId: newId,
  };
};

const postItem = newItem => {
  let apiURL = `${experienceAPIURL}/items`;
  return dispatch => {
    const config = { url: apiURL, method: 'POST', data: newItem };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(postItemError(response.statusText));
        }
        dispatch(postItemSuccess(response.data));
      })
      .catch(error => {
        onAuthError(error);
        dispatch(postItemError(error));
      });
  };
};

const patchItemError = error => {
  return {
    type: constants.PATCH_ITEM_ERROR,
    error,
  };
};

const patchItemSuccess = item => {
  return {
    type: constants.PATCH_ITEM_SUCCESS,
    item: item,
  };
};

const patchItem = item => {
  let apiURL = `${experienceAPIURL}/items/${item.id}`;
  return dispatch => {
    const config = { url: apiURL, method: 'PATCH', data: item };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(patchItemError(response.statusText));
        }
        dispatch(patchItemSuccess(response.data));
      })
      .catch(error => {
        onAuthError(error);
        dispatch(patchItemError(error));
      });
  };
};


const bulkDeleteItemsError = error => {
  return {
    type: constants.BULK_DELETE_ITEMS_ERROR,
    error,
  };
};

const bulkDeleteItemsSuccess = item => {
  return {
    type: constants.BULK_DELETE_ITEMS_SUCCESS,
    item: item,
  };
};

const bulkDeleteItemsInProgress = () => {
  return {
    type: constants.BULK_DELETE_ITEMS_INPROGRESS
  }
}


const bulkDeleteItems = items => {
  let apiURL = `${experienceAPIURL}/items/bulk`;
  return dispatch => {
    dispatch(bulkDeleteItemsInProgress());
    const config = { url: apiURL, method: 'DELETE', data: {
      items: items
    } };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(bulkDeleteItemsError(response.statusText));
        }
        dispatch(bulkDeleteItemsSuccess(response.data));
      })
      .catch(error => {
        onAuthError(error);
        dispatch(bulkDeleteItemsError(error));
      });
  };
};

const handleItemsScrollPos = pos => {
  return {
    type: constants.ITEMS_SCROLL_POS,
    scrollPos: pos
  }
}

export { getItemsByProviderId, getItems, getItemById, postItem, patchItem, bulkDeleteItems, bulkDeleteItemsSuccess, bulkDeleteItemsError, handleItemsScrollPos };
